// Importing necessary libraries and components
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import AgentSearchChipManager from "./AgentSearchChipManager";
import {
  getMerchantListData,
  setFormDataManager,
  clearFormDataManager,
  getManagerListData,
  getManagerListDataByID,
} from "../../Redux/Actions/merchantInformation";

// Custom styles for the component
const useStyles = makeStyles(styles);
const searchButtonStyles = makeStyles(theme => ({
  searchButton: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 14px 26px -12px rgb(153 153 153 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(153 153 153 / 20%)",
    },
  },
}));
// Main component for Search Dialog Manager
function SearchDialogManager(props) {
  const classes = useStyles();
  const searchButtonClasses = searchButtonStyles();
  const profileId = localStorage.getItem("profileId");
  const [id, setId] = React.useState(null);
  const [business1, setBusiness1] = React.useState("");
  const [manager1, setManager1] = React.useState("");
  const [managerId, setManagerId] = React.useState("");
  const [uid1, setUid1] = React.useState("");
  const [email1, setEmail1] = React.useState("");
  const [status1, setStatus1] = React.useState("");
  const [platform1, setPlatform1] = React.useState("");
  const [managerType1, setManagerType1] = React.useState("");

  // Function to clear form data
  const clearFormData = () => {
    const initialFormData = {
      searchBusinessName: "",
      searchManagerUID: "",
      searchEmail: "",
      searchStatus: null,
      searchStatusValue: "",
      searchManagerName: "",
      searchManagerId: "",
      searchPlatform: "",
      searchManagerType: "",
    };
    props.setFormDataManager(initialFormData);
  };

  const resetLocalFields = () => {
    setBusiness1("");
    setManager1("");
    setManagerId("");
    setUid1("");
    setEmail1("");
    setStatus1("");
    setPlatform1("");
    setManagerType1("");
  };

  // Effect to fetch ID from URL query parameters
  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    setId(idFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to handle dialog close
  const handleClose = () => {
    if (id) {
      const payloadWhenId = {
        Bussines_id: id,
        recordPerPage: 5,
        pageNo: 1,
      };
      props.getManagerListDataByID(payloadWhenId);
    } else if (id == null) {
      const payload = {
        Profile_Id: profileId,
        pageNo: 1,
        recordPerPage: 5,
      };
      props.getManagerListData(payload);
    }
    props.clearFormDataManager();
    clearFormData();
    resetLocalFields();
    props.clearChips();
  };
  // Function to handle input changes
  const onChange = e => {
    const { name, value } = e.target;

    if (name === "searchBusinessName") {
      setBusiness1(value);
    } else if (name === "searchManagerUID") {
      setUid1(value);
    } else if (name === "searchStatus") {
      setStatus1(value);
    } else if (name === "searchEmail") {
      setEmail1(value);
    } else if (name === "searchPlatform") {
      setPlatform1(value);
    } else if (name === "searchManagerType") {
      setManagerType1(value);
    }
  };

  const handleSetSearchManagerName = value => {
    setManager1(value);
  };

  const handleSetSearchManagerId = value => {
    setManagerId(value);
  };
  // Function to handle form submission
  const onFormSubmit = event => {
    event.preventDefault();
    const submitFormData = {
      searchBusinessName: business1.trim(),
      searchManagerName: manager1.trim(),
      searchManagerUID: uid1.trim(),
      searchEmail: email1.trim(),
      searchStatus: status1,
      searchStatusValue: "",
      searchManagerId: managerId,
      searchPlatform: platform1,
      searchManagerType: managerType1,
    };
    props.setFormDataManager(submitFormData);
    if (id) {
      const payloadWhenId = {
        Bussines_id: id,
        recordPerPage: 5,
        searchBusinessName: business1.trim(),
        searchManagerName: "",
        searchManagerUID: uid1.trim(),
        searchEmail: email1.trim(),
        searchStatus: status1,
        searchManagerId: managerId,
        searchPlatform: platform1,
        searchManagerType: managerType1,
        pageNo: 1,
      };
      const payloadWithManagerName = {
        ...payloadWhenId,
        searchManagerName: manager1.trim(),
      };
      props.seacrhChipData(payloadWithManagerName);
      props.close();
    } else if (
      id == null
    ) {
      const payload = {
        Profile_Id: profileId,
        pageNo: 1,
        recordPerPage: 5,
        searchBusinessName: business1.trim(),
        searchManagerName: "",
        searchManagerUID: uid1.trim(),
        searchEmail: email1.trim(),
        searchStatus: status1,
        searchManagerId: managerId,
        searchPlatform: platform1,
        searchManagerType: managerType1,
      };
      const payloadWithManagerName = {
        ...payload,
        searchManagerName: manager1.trim(),
      };
      props.seacrhChipData(payloadWithManagerName);
      props.close();
    }
  };

  // Effect to populate form fields from Redux state
  React.useEffect(() => {
    const formData = props.formData || {};
    setBusiness1(formData.searchBusinessName || "");
    setManager1(formData.searchManagerName || "");
    setUid1(formData.searchManagerUID || "");
    setEmail1(formData.searchEmail || "");
    setStatus1(formData.searchStatus || "");
    setManagerId(formData.searchManagerId || "");
    setPlatform1(formData.searchPlatform || "");
    setManagerType1(formData.searchManagerType || "");
  }, [props.formData]);

  const setParentSearchManagerName = value => {
    setManager1(value);
  };

  const setParentSearchManagerId = value => {
    setManagerId(value);
  };

  const handleInputChange = e => {
    setBusiness1(e.target.value);
  };

  const handleInputChange1 = e => {
    setUid1(e.target.value);
  };

  return (
    <>
      <form onSubmit={e => onFormSubmit(e)}>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
              }}
              label="Business Name"
              value={business1}
              onChange={handleInputChange}
              name="searchBusinessName"
              id="Business Name"
              style={{ fontSize: "82%" }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <AgentSearchChipManager
            onChange={(value, type) => {
              setFormDataManager({
                ...props?.formData,
                [type]: value,
              });
              props.seacrhChipData({ ...props?.formData, [type]: value });
              setParentSearchManagerName(value);
              setParentSearchManagerId(value);
            }}
            setParentSearchManagerName={handleSetSearchManagerName}
            setParentSearchManagerId={handleSetSearchManagerId}
            values={manager1}
            propsf={props.formData.searchManagerName}
            clearSearchManagerName={() => {
              dispatch(
                setFormDataManager({
                  ...props?.formData,
                  searchManagerName: "",
                  searchManagerId: "",
                })
              );
            }}
          />
        </Grid>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
              }}
              label="Manager UID"
              value={uid1}
              onChange={handleInputChange1}
              name="searchManagerUID"
              id="Manager UID"
              style={{ fontSize: "82%" }}
            />
          </Grid>
        </Grid>
        {/* <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
              }}
              label="Email address"
              value={email1}
              onChange={handleInputChange2}
              name="searchEmail"
              id="Email"
              style={{ fontSize: "82%" }}
            />
          </Grid>
        </Grid> */}
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select Status"
              label="Status"
              value={status1}
              onChange={onChange}
              name="searchStatus"
              id="Current_Status"
              select
              style={{ fontSize: "82%" }}
            >
              <MenuItem className={classes.dialogBoxDropDown} value="Invited">
                Invited
              </MenuItem>
              <MenuItem className={classes.dialogBoxDropDown} value="Active">
                Active
              </MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select Platform"
              label="Platform"
              value={platform1}
              onChange={onChange}
              name="searchPlatform"
              id="Platform"
              select
              style={{ fontSize: "82%" }}
            >
              <MenuItem className={classes.dialogBoxDropDown} value="WEB">
                WEB
              </MenuItem>
              <MenuItem className={classes.dialogBoxDropDown} value="API">
                API
              </MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select Manager Type"
              label="Manager Type"
              value={managerType1}
              onChange={onChange}
              name="searchManagerType"
              id="Manager_Type"
              select
              style={{ fontSize: "82%" }}
            >
              <MenuItem className={classes.dialogBoxDropDown} value="Primary Manager">
                Primary Manager
              </MenuItem>
              <MenuItem className={classes.dialogBoxDropDown} value="Secondary Manager">
                Secondary Manager
              </MenuItem>
              <MenuItem className={classes.dialogBoxDropDown} value="Sub-Manager">
                Sub-Manager
              </MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid
          container
          className={classes.margin}
          style={{ justifyContent: "end" }}
        >
          <Button
            variant="contained"
            className={classes.clearButton}
            disabled={
              business1 === ""
              && manager1 === ""
              && uid1 === ""
              && status1 === ""
              && email1 === ""
              && platform1 === ""
              && managerType1 === ""
            }
            onClick={() => handleClose()}
          >
            clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={`${classes.buttonStyle} ${searchButtonClasses.searchButton}`}
            disabled={
              business1 === ""
              && manager1 === ""
              && uid1 === ""
              && status1 === ""
              && email1 === ""
              && platform1 === ""
              && managerType1 === ""
            }
            type="submit"
          >
            Search
          </Button>
        </Grid>
      </form>
    </>
  );
}

// Prop types for the component
SearchDialogManager.propTypes = {
  close: PropTypes.func,
  tableData: PropTypes.object,
  seacrhChipData: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getManagerListData: PropTypes.func,
  getManagerListDataByID: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = app => ({
  formData: app.merchantInformation,
  formDataManager: app.merchantInformation,
  tableData: app.provideRegistration,
  userDetails: app.app,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  setFormDataManager,
  clearFormDataManager,
  getMerchantListData,
  getManagerListData,
  getManagerListDataByID,
})(SearchDialogManager);
